module.exports = __webpack_public_path__ + "img/49.97b6741.jpg";